export const mutations = {
  SET_LIST: (state, data) => {
    state.list = data;
  },
};